export default __webpack_public_path__ + "static/car-accidents-2af8f60d7610f9f33c7c60efbea26c90.jpg";